import styled from '@emotion/styled';
import {
  BackgroundImage,
  CUSTOM_BREAK_POINT,
} from 'components/Blocks/Block.styled';
import { GNB_HEIGHT } from 'components/GNB';
import {
  BACKGROUND_PRYMARY_DARK,
  BACKGROUND_PRYMARY_LIGHT,
} from 'constants/designSystem';
import { useEffect } from 'react';
import MintContent from './MintContent';

const Mint = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    window.dispatchEvent(new Event('scroll'));
  }, []);

  return (
    <MintWrapper>
      <Background.Container>
        <BackgroundImage
          size={140}
          top={205}
          right={10}
          src='/images/background/meteo_left.png'
          style={{ opacity: 0.15 }}
        />
        <BackgroundImage
          size={80}
          top={403}
          right={120}
          src='/images/background/meteo_left.png'
          style={{ opacity: 0.15 }}
        />
        <BackgroundImage
          size={86}
          top={119}
          left={80}
          src='/images/background/circle3.png'
        />
        <BackgroundImage
          size={254}
          bottom={-15}
          left={-56}
          src='/images/background/planet.png'
          style={{ opacity: 0.15 }}
        />
        <BackgroundImage
          size={91}
          bottom={100}
          left={243}
          src='/images/background/circle2.png'
          style={{ opacity: 0.15 }}
        />
      </Background.Container>
      <ContentBlock>
        <ImageWrapper>
          <ImageBg move={30} />
          <ImageBg move={15} />
          <Video
            autoPlay
            loop
            muted
            playsInline
            poster='/images/gummy_mint.png'
          >
            <source src='/videos/mint_video.mp4' type='video/mp4' />
            Sorry, your browser doesn't support embedded videos.
          </Video>
          {/* <Image src='/images/gummy_mint.png' alt='gummy_mint' /> */}
        </ImageWrapper>

        <MintContent />
      </ContentBlock>
    </MintWrapper>
  );
};

const MintWrapper = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: ${GNB_HEIGHT}px;

  position: relative;
  background-color: var(--bg-color);
  min-height: calc(100vh - ${GNB_HEIGHT}px);

  &::before {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
    /* background: linear-gradient(
      to top,
      ${BACKGROUND_PRYMARY_DARK},
      ${BACKGROUND_PRYMARY_LIGHT}
    ); */
    background-color: #000000;
  }
`;

const Background = {
  Container: styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
  `,
  MeteoLeft: styled.img`
    width: 155px;
    height: 140px;
    position: absolute;
    top: 318px;
    right: 0px;
  `,
};

const ContentBlock = styled.div`
  position: relative;
  max-width: 1308px;
  margin: 50px auto 60px;
  padding: 54px 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 128px;

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    margin: 0;
    gap: 64px;
  }
`;

const ImageWrapper = styled.div`
  width: 360px;
  height: 360px;
  align-self: flex-start;
  position: relative;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  max-width: 360px;
  max-height: 360px;
  border: 3px solid #ffffff;
  position: absolute;
  background-color: var(--bg-color);
  box-sizing: border-box;
  object-fit: cover;
`;

const ImageBg = styled.div<{ move: number }>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: ${(props) => props.move}px;
  left: ${(props) => props.move}px;
  border: 3px solid #ffffff;
  box-sizing: border-box;
  background-color: var(--bg-color);
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  max-width: 360px;
  max-height: 360px;
  border: 3px solid #ffffff;
  position: absolute;
  background-color: var(--bg-color);
  box-sizing: border-box;
  object-fit: cover;
`;

export default Mint;
